import { CompanyRegistration } from "../companyRegistration";
import { Candidate } from "../search/candidate";
import { Job } from "../search/job";

export class Recommendation {
	Id: number;
	Title: string;
	RecommendedByUserId: number;
	IsNotifyCandidate?: boolean;
	IsNotifyRecruiter?: boolean;
	IsNotifyCompany?: boolean;
	IsSubmitted?: boolean;
	CreatedDate?: Date;
	SubmittedDate?: Date;
	Jobs: Job[];
  	Candidates: Candidate[];
	Companies: CompanyRegistration[];
	TotalRecommendedCandidates: number;
	TotalRecommendedJobs: number;
	TotalRecommendedCompanies: number;
	TotalRecords: number = 0;
}
